import { render, staticRenderFns } from "./WsPopupAlert.vue?vue&type=template&id=034c3a8f&"
import script from "./WsPopupAlert.vue?vue&type=script&lang=js&"
export * from "./WsPopupAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports